var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-52caf553"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "hidden shadow-custom fixed top-0 left-0 z-20 flex-col justify-betweee w-24 h-full bg-white lg:flex"
};
var _hoisted_2 = { class: "flex justify-center py-7 items-center" };
var _hoisted_3 = { class: "flex flex-col justify-center flex-grow" };
var _hoisted_4 = { class: "link" };
var _hoisted_5 = { class: "link__button" };
var _hoisted_6 = { class: "link__tooltip" };
var _hoisted_7 = { class: "link" };
var _hoisted_8 = { class: "link__button" };
var _hoisted_9 = { class: "link__tooltip" };
var _hoisted_10 = { class: "link__button" };
var _hoisted_11 = {
    key: 0,
    class: "link__badge"
};
var _hoisted_12 = { class: "link__tooltip" };
import { planFeatures } from '@common/utils/Plans';
import { canUseFeature } from '@common/modules/school';
import { ChatStore } from '@common/stores';
import Auth from '@common/modules/auth';
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from "vue-i18n";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BaseSidebarNav',
    setup: function (__props) {
        var _this = this;
        var route = useRoute();
        var currentDir = ref('');
        var t = useI18n().t;
        var visible = computed(function () {
            return !['courseAbout', 'courseAboutOld'].includes(currentDir.value);
        });
        var totalUnreadMessages = computed(function () { return ChatStore.totalUnreadMessages; });
        var chatVisible = computed(function () { return !ChatStore.hidden; });
        var canUseChat = computed(function () { return canUseFeature(planFeatures.CHAT_FEATURE_CODE); });
        watch(route, function (to) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                currentDir.value = to.name;
                return [2 /*return*/];
            });
        }); }, { immediate: true });
        var showMessages = function () {
            if (canUseChat.value) {
                ChatStore.show();
            }
        };
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_link = _resolveComponent("e-link");
            return (!_unref(Auth).isGuest() && visible.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_e_icon, {
                            class: "w-6 h-6 text-gray-200",
                            icon: "text-lines"
                        })
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_e_link, {
                            class: _normalizeClass([
                                {
                                    'link--active': currentDir.value && currentDir.value.startsWith('course')
                                }
                            ]),
                            "href-to": { name: 'schoolCatalog' }
                        }, {
                            default: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _createVNode(_component_e_icon, {
                                            class: "w-7 h-7",
                                            icon: "bicolor/courses"
                                        }),
                                        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('sidebar.courseCatalog')), 1)
                                    ])
                                ])
                            ]; }),
                            _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_e_link, {
                            class: _normalizeClass([
                                {
                                    'link--active': currentDir.value && currentDir.value.startsWith('library')
                                }
                            ]),
                            "href-to": { name: 'library' }
                        }, {
                            default: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createVNode(_component_e_icon, {
                                            class: "w-7.5 h-7.5",
                                            icon: "bicolor/book"
                                        }),
                                        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('sidebar.library')), 1)
                                    ])
                                ])
                            ]; }),
                            _: 1
                        }, 8, ["class"]),
                        (!_unref(Auth).isGuest() && canUseChat.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass([[
                                        chatVisible.value ? 'text-primary' : 'text-gray-300'
                                    ], "link"]),
                                onClick: showMessages
                            }, [
                                _createElementVNode("div", _hoisted_10, [
                                    (totalUnreadMessages.value > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(totalUnreadMessages.value), 1))
                                        : _createCommentVNode("", true),
                                    _createVNode(_component_e_icon, {
                                        class: "w-7 h-7",
                                        icon: "bicolor/chat"
                                    }),
                                    _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('sidebar.chat')), 1)
                                ])
                            ], 2))
                            : _createCommentVNode("", true)
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
